import { toLandingLeadForm } from '../articles/v4/landing_lead_form';

pageLoad('pages_how_to_choose_box', () => {
  $('.summary-block .summary-button').on('click', toLandingLeadForm);
});
